"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITargetType = void 0;
var ITargetType;
(function (ITargetType) {
    ITargetType["Seconds"] = "seconds";
    ITargetType["Meters"] = "meters";
    ITargetType["Calories"] = "calories";
})(ITargetType || (exports.ITargetType = ITargetType = {}));
//# sourceMappingURL=target-type.js.map